export default __webpack_public_path__ + "static/media/danskeheadline-webfont.4357171a.woff";